export default "__VITE_ASSET__BlJrNnVq__"